var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C11.75 0 5 6.75 5 15H0L7.5 25L15 15H10C10 9.45 14.45 5 20 5V0ZM32.5 5L25 15H30C30 20.55 25.55 25 20 25V30C28.25 30 35 23.25 35 15H40L32.5 5Z",
    fill: "#D9880E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5319 27.5985V27.7099L22.6147 27.7844L24.279 29.2815C24.907 29.8467 24.907 30.7507 24.279 31.3159C23.6356 31.8947 22.5825 31.8947 21.9392 31.3159L19.7211 29.3203C19.3794 29.0129 19.2275 28.6098 19.2527 28.22L19.2537 28.2041L19.2527 28.1882C19.2509 28.1598 19.25 28.1317 19.25 28.1038V24.7013C19.25 23.9239 19.9591 23.25 20.891 23.25C21.8228 23.25 22.5319 23.9239 22.5319 24.7013V27.5985Z",
    fill: "#D9880E",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 28C30.75 33.3848 26.3848 37.75 21 37.75C15.6152 37.75 11.25 33.3848 11.25 28C11.25 22.6152 15.6152 18.25 21 18.25C26.3848 18.25 30.75 22.6152 30.75 28ZM14.0532 28C14.0532 31.8366 17.1634 34.9468 21 34.9468C24.8366 34.9468 27.9468 31.8366 27.9468 28C27.9468 24.1634 24.8366 21.0532 21 21.0532C17.1634 21.0532 14.0532 24.1634 14.0532 28Z",
    fill: "#D9880E",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrder);
export default __webpack_public_path__ + "static/media/pendingOrder.18f82bd51502a782219b65cc51370f69.svg";
export { ForwardRef as ReactComponent };